import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/tabs/style/index.tsx